/* ============================================================
   Passi nei Sassi — shared chrome behaviours
   Header solid-on-scroll · sticky mobile CTA · mobile drawer · reveal-on-view
   Loaded on every template. Kept 1:1 with the original pages, de-duplicated
   so page-level scripts never re-bind the same handlers.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- header solid + sticky mobile CTA ---------- */
  var hdr = document.getElementById('hdr');
  var mobCta = document.getElementById('mobCta');
  var hero = document.querySelector('.hero, .lx-hero, .about-hero');

  function onScroll() {
    var sc = window.scrollY || window.pageYOffset;
    if (hdr) hdr.classList.toggle('solid', sc > 50);
    if (mobCta && hero) {
      var heroBottom = hero.offsetTop + hero.offsetHeight - 110;
      mobCta.classList.toggle('show', sc > heroBottom);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- mobile drawer (lx-) ---------- */
  var toggle = document.querySelector('.lx-burger');
  var drawer = document.getElementById('navDrawer');
  var scrim = document.querySelector('.lx-scrim');
  if (toggle && drawer) {
    var setOpen = function (open) {
      document.body.classList.toggle('nav-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Chiudi menù' : 'Apri menù');
    };
    toggle.addEventListener('click', function () {
      setOpen(!document.body.classList.contains('nav-open'));
    });
    if (scrim) scrim.addEventListener('click', function () { setOpen(false); });
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { setOpen(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains('nav-open')) setOpen(false);
    });
  }

  /* ---------- reveal on view ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
  }
})();
